import styled from "@emotion/styled";
import { Toys } from "@mui/icons-material";
import { Container, Typography } from "@mui/material";
import {Grid} from "@mui/material";

const MainContainer = styled(Container)`
    background-image:url("./assets/shizu.png");
    background-size:contain;
    background-position:bottom;
    background-repeat:no-repeat;
    margin-top:30px;
    @media(max-width: 600px){
        padding-bottom:20px;
    }
    @media (min-width: 600px){
    padding-top:50px;
    padding-bottom:50px;
    margin-top:50px;
    background-position:center center;
    }
`
const WrapperGrid = styled(Grid)`
`
const Heading = styled(Typography)`
    font-family:GaeguBold;
    font-size:70px;
    color:#2A3382;
    text-transform:uppercase;
    @media (max-width: 749px){
        font-size:50px;
    }
`
const SubHeading = styled(Typography)`
    font-family:Poppins;
    font-size:16px;
    color:#FF9A55;
    text-transform:uppercase;
`

export default function Supply(){
    return(
        <MainContainer >
            <WrapperGrid container spacing={2}>
                <Grid item xs={12}>
                    <Heading>Supply</Heading>
                </Grid>
                <Grid item xs={12}>
                    <SubHeading>1,000,000,000,000</SubHeading>
                </Grid>
                <Grid item xs={12}>
                    <Heading>Liquidity</Heading>
                </Grid>
                <Grid item xs={12}>
                    <SubHeading>1 Month</SubHeading>
                </Grid>
                <Grid item xs={12}>
                    <Heading>Taxes</Heading>
                </Grid>
                <Grid item xs={12}>
                    <SubHeading>1/1</SubHeading>
                </Grid>
            </WrapperGrid>
        </MainContainer>
    );
}